import { createStitches } from '@stitches/react'
import type * as Stitches from '@stitches/react'
import commonTheme from './common'
import lightThemeOpts from './light-theme'
import darkThemeOpts from './dark-theme'

const {
  styled,
  css,
  globalCss,
  keyframes,
  getCssText,
  createTheme,
  theme,
  config,
} = createStitches({
  ...commonTheme,
  theme: {
    ...commonTheme.theme,
    colors: {
      ...commonTheme.theme.colors,
      ...lightThemeOpts.colors,
    },
    shadows: {
      ...commonTheme.theme.shadows,
    },
  },
})

// Create and export the light and dark themes
export const lightTheme = createTheme('light-theme', lightThemeOpts)
export const darkTheme = createTheme('dark-theme', darkThemeOpts)

// Export the type for CSS using the config
export type CSS = Stitches.CSS<typeof config>
export type VariantProps<T extends {}> = Stitches.VariantProps<T>
export type StitchesTheme = typeof theme

// Export utilities
export {
  styled,
  css,
  globalCss,
  keyframes,
  getCssText,
  theme,
  config,
  createTheme,
}
